import {defineStore} from 'pinia';

/** State shape for the oopsie error page store */
export interface OopsieStoreStoreState {
  oopsPageTemplateVisible: boolean,
}

export const useOopsieStore =
  /** Controls the visibility of the error page template */
  defineStore<'oopsie-store', OopsieStoreStoreState, any, any>('oopsie-store', {
  state: () => ({
    oopsPageTemplateVisible: false,
  }),
});